// extracted by mini-css-extract-plugin
export var dropdown = "_tb-0";
export var imageWrapper = "_tb-3";
export var itemNameContainer = "_tb-1";
export var productImage = "_tb-2";
export var spinnerWrapper = "_tb-4";